import React, { useState, useEffect, useRef } from 'react' 
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlay } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { useGetUser } from '../../hooks/useGetUser';
import { Select, MenuItem, InputLabel, RadioGroup, FormControlLabel, Radio,
         FormLabel, createMuiTheme, MuiThemeProvider, Checkbox, Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/pt-br"
import FormData from 'form-data'
import styles from './styles.module.scss'
import ButtonsImagesCampain from '../../components/ButtonsImagesCampain'
import Paginacao from '../../components/Paginacao'
import { getParceiros, getRegional, getFilial, 
            saveAcao, getCampanhaWithId, postEncerrarCampanha, editAcao, contatosFinalizados, getListaParceirosAcao, getParceiroLogImportacao, postParceirosImportacaoExcel } from '../../services/api-auto';
import ParceiroCard from '../../components/ParceiroCard';
import modeloParticipanteCampanha from '../../assets/docs/modeloParticipanteCampanha.xlsx'
import Paticipantes from '../../views/AdicionarCampanha/ModalImportacao';


import { useDispatch } from "react-redux"
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';
import { useDebounce } from '../../hooks/debounceHook'
import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons'

import ModalLoading from '../../components/ModalLoading'
import Modal from '../../components/Modal/Modal'



const dataInit = {
    id: '',
    nome: '',
    dataInicio: moment(),
    dataFim:  moment(),
    tipo: 0,
    status: 0,
    descricao: '',
    mensagem: '',
    logoDesktop: null,
    logoMobile: null,
    destaqueDesktop: null,
    destaqueMobile: null,
    conteudoDesktop: null,
    conteudoMobile: null,
    logoDesktopBlob: null,
    logoMobileBlob: null,
    destaqueDesktopBlob: null,
    destaqueMobileBlob: null,
    conteudoDesktopBlob: null,
    conteudoMobileBlob: null,
    parceiroAcaoExcluidos: [],
    parceiroAcaoAdicionar: [],
}

const publicoAlvoInit = {
    todos: false,
    gerenteRelacionamento: false,
    gerenteFilial: false,
    superintendente: false,
    loja: false,
    vendedor: false
}

const configuracaoPremiacaoInit = {
    existe: 'sim',
    tipo: '0',
    link: '',
    acompanhante: false,
    quantidade: 0,
    descricao: ''
}

const AdicionarCampanha = () => {
    const [openModalConfirmation, setOpenModalConfirmation] = React.useState(false);
    const handleOpenModalConfirmation = () => {
        setOpenModalConfirmation(true)
    };
    const closeModalConfirmation = () => { setOpenModalConfirmation(false) };
  
    const [openModalComplete, setOpenModalComplete] = React.useState(false);
    const handleOpenModalComplete = () => {
        setOpenModalComplete(true)
    };
    const closeModalComplete = () => { setOpenModalComplete(false) };

    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));
    const [dados, setDados] = useState(null)
    const [loading, setLoading] = useState(false);
    const [logList, setLogList] = useState([]);
    const ref = useRef(null)

    const [buscar, setBuscar] = useState('');
    const [ativarBuscar, setAtivarBuscar] = useState(false);

    const history = useHistory()
    const [data, setData] = useState(dataInit);
    const [configuracaoPublico,setConfiguracaoPublico] = useState(publicoAlvoInit)

    const [configuracaoPremiacao, setConfiguracaoPremiacao] = useState(configuracaoPremiacaoInit)

    const [regional, setRegional] = useState([]);
    const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
    const [filial, setFilial] = useState([]);
    const [filialSelecionado, setFilialSelecionado] = useState('todos');
    const [parceiros, setParceiros] = useState([]);
    const [participantes, setParticipantes] = useState([]);
    const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
    const [nomeParceiroSelecionado, setNomeParceiroSelecionado] = useState('todos');
    const [ parceiroAcaoPresentes, setParceiroAcaoPresentes] = useState([])
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const testStyle = {
        backgroundColor:{ xs: 'secondary.light', sm: "#0000ff"}
    }

    const validarForm = () => {
        let valid = true
        let msg = ""

        if(!data.nome){
            let msg = `Campo nome obrigatório`; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.dataInicio){
            msg = "Campo De é obrigatório\n"; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.dataFim){
            msg = "Campo para é obrigatório\n"; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.descricao){
            msg = "Campo descrição é obrigatório\n"; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.mensagem){
            msg = "Campo mensagem é obrigatório\n"; 
            valid = false; 
            showMsgW(msg)
        }
        if( !data.logoDesktop  && !data.logoDesktopBlob ){
             msg = "Campo mensagem é obrigatório\n"; 
             valid = false; 
             showMsgW(msg)
        }
         if( !data.logoMobile  && !data.logoMobileBlob ){
             msg = "Logo é obrigatória\n"; 
             valid = false; 
             showMsgW(msg)
        }
        if(!data.mensagem){
            msg = "Campo mensagem é obrigatórios\n"; 
            valid = false; 
            showMsgW(msg)
        }
        
        if( !data.id && !Boolean(data.parceiroAcaoAdicionar.length) ) { 
            msg = "Parceiro é obrigatório para novas campanhas\n"; 
            valid = false; 
            setIndicarErros(true)
            showMsgW(msg)
        }
        
        return valid
    }

    const findLojasParticipantesCadastradas = async () => {
//        if(buscar !== ''){
            setModalLoading(true)
            try{
                const info = await getListaParceirosAcao(data.id, buscar)
                // setPagina(1)
                // setParceiros(info.data.data)
                // setMaxPage(info.data.maxPage)
                setAtivarBuscar(true)
                setParceiroAcaoPresentes(info.data)
                setMaxPage(info.maxPage)
            }catch(e){
                showMsgE("Ocorreu um erro e não foi possível carregar dados")
            }finally{
                setModalLoading(false)
            }
//        } else{
//            setAtivarBuscar(false)
//            getParceiros();
//        }
        }
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
      
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    const encerrar = async() => {
        setModalLoading(true)
        await postEncerrarCampanha(data.id);
        setModalLoading(false)
        history.push('/campanhas')
    }

    const getCampanhaIfEdit = async (id) => {
        if(id){
            setModalLoading(true)
            try{
                const info = await getCampanhaWithId(id);

                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64data = reader.result;    
                }

                const blob = new Blob([info.imagemLogo.fileContents], {type: info.imagemLogo.contentType})
                //reader.readAsDataURL(info.imagemLogo.fileContents);  

                setData({
                    ...data,
                    id: info.id,
                    nome: info.nome,
                    dataInicio: moment(info.periodoInicial),
                    dataFim:  moment(info.periodoFinal),
                    tipo: info.tipo,
                    status: info.status,
                    descricao: info.descricao,
                    mensagem: info.mensagemPersonalizada || null,
                    logoDesktopBlob: b64toBlob(info.imagemLogo.fileContents, info.imagemLogo.contentType),
                    logoMobileBlob: b64toBlob(info.imagemComoFunciona.fileContents, info.imagemComoFunciona.contentType),
                    destaqueDesktopBlob: null,
                    destaqueMobileBlob: null,
                    conteudoDesktopBlob: null,
                    conteudoMobileBlob: null,
                })

                pesquisar(info.id)

                setConfiguracaoPublico({
                    todos: info.todosPA,
                    gerenteRelacionamento: info.gerenteRelacionamentoPA,
                    gerenteFilial: info.gerenteFilialPA,
                    superintendente: info.superintendentePA,
                    loja: info.lojaPA,
                    vendedor: info.vendedorPA
                })

                setConfiguracaoPremiacao({
                    existe: 'sim',
                    tipo: '0',
                    link: '',
                    acompanhante: false,
                    quantidade: 0,
                    descricao: ''
                })
            } catch(e){
                showMsgW('Não foi possível carregar os dados')
            }
            setModalLoading(false)
        }

        

    }

    const adicionarParceiro = () => {
        const obj = {
            "regional": regionalSelecionado,
            "filial": filialSelecionado,
            "nomeParceiro": nomeParceiroSelecionado,
            "idParceiro": parceiroSelecionado,
        }
        //parceiroAcaoAdicionar
        setData({ ...data, parceiroAcaoAdicionar: [ ...data.parceiroAcaoAdicionar, obj ]});
    }

    const removerParceiro = ( parceiro ) => {
        let adicionados = [...data.parceiroAcaoAdicionar];
        let index = adicionados.findIndex( item => item === parceiro)
        adicionados.splice(index,1)
        setData({ ...data, parceiroAcaoAdicionar: adicionados})
    }
    const deletarParceiro = (parceiro, i) => {
        var novoData = {
            ...data,
            parceiroAcaoExcluidos: [
                ...data.parceiroAcaoExcluidos,
                parceiro
            ]
        };

        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes];
        novoParceiroAcaoPresentes.splice(i, 1);
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }

    const carregarRegional = async () =>{
        const info = await getRegional()
        setRegional(info);
    }

    const carregarFilial = async () =>{
        const info = await getFilial(regionalSelecionado)
        setFilial(info);
    }

    const carregarParceiro = async () =>{
        const info = await getParceiros(regionalSelecionado, filialSelecionado)
        setParceiros(info);
    }

    const changeConfiguracaoPublico = async (variavel, valor) => {
        if(variavel === 'todos'){
            setConfiguracaoPublico({
                todos: valor,
                gerenteFilial: valor,
                gerenteRelacionamento: valor,
                superintendente: valor,
                loja: valor,
                vendedor: valor
            })
        } else{
            setConfiguracaoPublico({
                ...configuracaoPublico,
                [variavel]: valor
            })
        }
    }

    const createSenderForm = () => {
        let formdata = new FormData();

        if( data.id !== '' ){ formdata.append("id", data.id); }
        formdata.append("nome", data.nome)
        formdata.append('PeriodoInicial', data.dataInicio.format('DD/MM/YYYY'))
        formdata.append('PeriodoFinal', data.dataFim.format('DD/MM/YYYY'))
        formdata.append('Tipo', data.tipo)
        formdata.append('Status', data.status)
        formdata.append('Descricao', data.descricao)
        formdata.append('MensagemPersonalizada', data.mensagem)
        formdata.append('TodosPA', Boolean(configuracaoPublico.todos))
        formdata.append('GerenteRelacionamentoPA', Boolean(configuracaoPublico.gerenteRelacionamento))
        formdata.append('GerenteFilialPA', Boolean(configuracaoPublico.gerenteFilial))
        formdata.append('SuperintendentePA', Boolean(configuracaoPublico.superintendente))
        formdata.append('LojaPA', Boolean(configuracaoPublico.loja))
        formdata.append('VendedorPA', Boolean(configuracaoPublico.vendedor))
        for(let i = 0; i < data.parceiroAcaoAdicionar.length; i++){
            formdata.append(`ParceiroAcao[${i}].idParceiro`, data.parceiroAcaoAdicionar[i].idParceiro);
            formdata.append(`ParceiroAcao[${i}].regional`, data.parceiroAcaoAdicionar[i].regional);
            formdata.append(`ParceiroAcao[${i}].filial`, data.parceiroAcaoAdicionar[i].filial);
            formdata.append(`ParceiroAcao[${i}].nomeParceiro`, data.parceiroAcaoAdicionar[i].nomeParceiro);
        }
        for(let i = 0; i < data.parceiroAcaoExcluidos.length; i++){
            formdata.append(`ParceiroAcaoExcluidos[${i}].idParceiro`, data.parceiroAcaoExcluidos[i].idParceiro);
            formdata.append(`ParceiroAcaoExcluidos[${i}].regional`, data.parceiroAcaoExcluidos[i].regional);
            formdata.append(`ParceiroAcaoExcluidos[${i}].filial`, data.parceiroAcaoExcluidos[i].filial);
            formdata.append(`ParceiroAcaoExcluidos[${i}].nomeParceiro`, data.parceiroAcaoExcluidos[i].nomeParceiro);
        }
        //formdata.append(`ParceiroAcao`, JSON.stringify(configuracaoLojasFinal));
        formdata.append('Premiacao', (configuracaoPremiacao.existe === 'sim'))
        formdata.append('TipoBeneficio', configuracaoPremiacao.tipo)
        formdata.append('LinkBeneficio', configuracaoPremiacao.link)
        formdata.append('AceitaAcompanhante', (configuracaoPremiacao.acompanhante === 'sim'))
        formdata.append('Quantidade', configuracaoPremiacao.quantidade)
        formdata.append('Conteudo', configuracaoPremiacao.descricao)
        formdata.append('ImagemLogo', data.logoDesktop)
        formdata.append('ImagemComoFunciona', data.logoMobile)

        return formdata;
    }

    const enviar = async() => {
       
        setIndicarErros(false)
        if(validarForm()){
            let formdata = createSenderForm()
            
            if( data.id !== '' ){
                setModalLoading(true)
                try{
                    let info = await editAcao(formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/campanhas')
                    }, 2000)
                } catch(e){
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false)
            } else{
                setModalLoading(true)
                try{
                    let info = await saveAcao(formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/campanhas')
                    }, 2000)
                } catch(e){
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false)
            }
        }
    }

    const pesquisar = async (id) => {
        const info = await getListaParceirosAcao(id, search, page)
        setParceiroAcaoPresentes(info.data)
        setMaxPage(info.maxPage)
    }

    const onFileChange = (event) => {
        let file;
        if (event.target.files && event.target.files[0]) {
            file = event.target.files[0];
            if(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                setDados(file);
            }else{
                showMsgE('Favor escolher arquivos .xlsx')
            }
        }
    };

    const callFileInput = () =>{
        ref.current.click()
    }

    const getLogList = async () => {
        const info = await getParceiroLogImportacao(page)
        setLogList(info.data.data)
        setMaxPage(info.data.maxPage)
    }

    const parceiroImportacaoExcel = async () => {
        setLoading(true)
        const formdata = new FormData();
        formdata.append('dados', dados)
        
        try{
            const participantesApi = await postParceirosImportacaoExcel(formdata);
            const participantes = participantesApi.parceirosImportacaoExcelResponde

            setParticipantes(participantes);
            
            participantes.map((participante) => {
                 const obj = {
                     "regional": participante.regional,
                     "filial": participante.filial,
                     "nomeParceiro": participante.nomeParceiro,
                     "idParceiro": participante.idParceiro,
                     "aviso": participante.aviso,
                 }

                 if(!obj.aviso){
                    data.parceiroAcaoAdicionar.push(obj);
                    //setData({ ...data, parceiroAcaoAdicionar: [ ...data.parceiroAcaoAdicionar, obj]});    
                 }     
            })

            setOpenModalComplete(true);
         
            if(Boolean(participantesApi.sucesso)){
                showMsgS("Planilha processada com sucesso")
                setLoading(false);
            } else if(Boolean(participantesApi.parciamente)){
                showMsgW("Planilha parcialmente importada")
                setLoading(false);
            }
        }catch(e){
            showMsgE("Planilha não processada")
            setOpenModalComplete(false);
        }finally{
            setLoading(false)
        }
    }

    useDebounce(search, 750, () => { pesquisar(data.id) });

    useEffect( () =>{
        if(
            !configuracaoPublico.todos &&
            configuracaoPublico.gerenteFilial &&
            configuracaoPublico.gerenteRelacionamento &&
            configuracaoPublico.superintendente &&
            configuracaoPublico.loja &&
            configuracaoPublico.vendedor
        ){
            setConfiguracaoPublico({
                ...configuracaoPublico,
                todos: true
            })
        } else if (
            configuracaoPublico.todos &&
            (
                !configuracaoPublico.gerenteFilial ||
                !configuracaoPublico.gerenteRelacionamento ||
                !configuracaoPublico.superintendente ||
                !configuracaoPublico.loja ||
                !configuracaoPublico.vendedor
            )
        ){
            setConfiguracaoPublico({
                ...configuracaoPublico,
                todos: false
            })
        }
    },[configuracaoPublico])

    useEffect(() => {
        carregarRegional();
        const campanha = new URLSearchParams(history.location.search).get("campanha")
        getCampanhaIfEdit(campanha)
    },[])

    useEffect( () => {
        if(regionalSelecionado){
            carregarFilial();
        }
    },[regionalSelecionado])

    useEffect( () => {
        if(filialSelecionado){
            carregarParceiro();
        }
    },[filialSelecionado])

    useEffect( () => {
        if(data.id){
            pesquisar(data.id)
        }
    }, [page])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };

const user = useGetUser();

    return (
        <>
        {(user.perfilAcesso === 'Master') && (
            <>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        Cadastro de Campanhas
                        <button className={styles.backButton} onClick={() => {history.goBack()}}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                    </div>
                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                                <FormControl className={styles.nome}>
                                    <TextField  type="text"  size="small"
                                        onChange={(e) => {setData({ ...data, nome:e.target.value})}}
                                        label="Nome da ação"
                                        value={data.nome}
                                        variant="filled"
                                        error={indicarErros && !data.nome ? true : false}
                                        className="customFilledInput"
                                    />
                                </FormControl>
                                <FormControl className={styles.data}>
                                    <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            label="De"
                                            format="DD/MM/yyyy"
                                            value={data.dataInicio}
                                            InputAdornmentProps={{ position: "start" }}
                                            onChange={novaData => { setData({ ...data, dataInicio:novaData}) }}
                                            className="customFilledInput"
                                            error={indicarErros && !data.dataInicio ? true : false}
                                            invalidDateMessage="Data em formato inválido."
                                            maxDateMessage="Data não deve ser maior que a data máxima."
                                            minDateMessage="Data não deve ser menor que a data mínima."
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormControl>
                                <FormControl className={styles.data}>
                                    <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            label="Até"
                                            format="DD/MM/yyyy"
                                            value={data.dataFim}
                                            InputAdornmentProps={{ position: "start" }}
                                            onChange={novaData => { setData({ ...data, dataFim:novaData}) }}
                                            className="customFilledInput"
                                            error={indicarErros && !data.dataFim ? true : false}
                                            invalidDateMessage="Data em formato inválido."
                                            maxDateMessage="Data não deve ser maior que a data máxima."
                                            minDateMessage="Data não deve ser menor que a data mínima."
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormControl>
                                <FormControl className={styles.half}>
                                    <InputLabel id="select-tipo-label" className={styles.label}>
                                        Tipo de ação
                                    </InputLabel>
                                    <Select
                                        labelId='select-tipo-label'
                                        label="Tipo de ação"
                                        onChange={(e)=>{setData({...data, tipo: e.target.value})}}
                                        value={data.tipo}
                                        variant='filled'
                                        className="customFilledInput"
                                    >
                                        <MenuItem value={0}>Programa</MenuItem>
                                        <MenuItem value={1}>Campanha</MenuItem>
                                        {/*<MenuItem value={2}>Guerrilha</MenuItem>*/}
                                    </Select>
                                </FormControl>
                                <FormControl className={styles.half}>
                                    <InputLabel id="select-status-label" className={styles.label}>
                                        Status
                                    </InputLabel>
                                    <Select
                                        labelId='select-status-label'
                                        label="Status"
                                        onChange={(e)=>{setData({...data, status: e.target.value})}}
                                        value={data.status}
                                        variant="filled"
                                        className="customFilledInput"
                                    >
                                        <MenuItem value={0}>Rascunho</MenuItem>
                                        <MenuItem value={1}>Ativo</MenuItem>
                                        <MenuItem value={2}>Encerrado</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth>
                                    <TextField  type="text"  size="small" 
                                        onChange={(e) => {setData({ ...data, descricao:e.target.value})}}
                                        label="Descrição"
                                        value={data.descricao}
                                        variant="filled"
                                        multiline
                                        className={`customFilledInput ${styles.padding10}`}
                                        error={indicarErros && !data.descricao ? true : false}
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <TextField  type="text"  size="small"
                                        onChange={(e) => {setData({ ...data, mensagem:e.target.value})}}
                                        label="Mensagem Personalizada"
                                        value={data.mensagem}
                                        variant="filled"
                                        multiline
                                        className={`customFilledInput ${styles.padding10}`}
                                        error={indicarErros && !data.mensagem ? true : false}
                                    />
                                </FormControl>

                            </div>
                        </div>
                    </div>
                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card}>
                                <div className={styles.subtitle}>
                                    Imagens
                                </div>
                                <div className={styles.divImageList}>
                                    <ButtonsImagesCampain
                                        texto = 'Banner da campanha exibido na área de destaque'
                                        width = '1200'
                                        height = '600'
                                        widthMM = '317.5'
                                        heightMM = '158.75'
                                        image={data.logoDesktop}
                                        blob={data.logoDesktopBlob}
                                        changeImage={(file)=>{setData({...data, 'logoDesktop':file})}}
                                        error={indicarErros && !data.logoDesktop && !data.logoDesktopBlob ? true : false}
                                    />
                                    <ButtonsImagesCampain
                                        texto = 'Banner descritivo exibido no detalhe da campanha'
                                        width = '800'
                                        height = '800'
                                        widthMM = '264.58'
                                        heightMM = '264.58'
                                        image={data.logoMobile}
                                        blob={data.logoMobileBlob}
                                        changeImage={(file)=>{setData({...data, 'logoMobile':file})}}
                                        error={indicarErros && !data.logoMobile && !data.logoDesktopBlob ? true : false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                        <div className={styles.content}>
                            <div className={styles.card}>

                                <div className={styles.subtitle}>
                                    Configuração
                                </div>
                                <div className={styles.topSpacing}>
                                <div className={styles.subtitleConfiguracao}>
                                    Público-alvo
                                </div>
                                <FormControl component="fieldset">
                                    <FormControlLabel value="todos" control={
                                        <Checkbox style={{color: '#5CCBE1' }}
                                            checked={configuracaoPublico.todos}
                                            onChange={e => {changeConfiguracaoPublico('todos',e.target.checked)}}
                                        />
                                    } label="Todos" className={styles.radioOptions}/>
                                    <FormControlLabel value="Gerente de relacionamento" control={
                                        <Checkbox style={{color: '#5CCBE1' }}
                                            checked={configuracaoPublico.gerenteRelacionamento}
                                            onChange={e => {changeConfiguracaoPublico('gerenteRelacionamento',e.target.checked)}}
                                        />
                                    } label="Gerente de relacionamento"  className={styles.radioOptions}/>
                                    <FormControlLabel value="Gerente de filial" control={
                                        <Checkbox style={{color: '#5CCBE1' }}
                                            checked={configuracaoPublico.gerenteFilial}
                                            onChange={e => {changeConfiguracaoPublico('gerenteFilial',e.target.checked)}}
                                        />
                                    } label="Gerente de filial"  className={styles.radioOptions}/>
                                    <FormControlLabel value="Superintendente" control={
                                        <Checkbox style={{color: '#5CCBE1' }}
                                            checked={configuracaoPublico.superintendente}
                                            onChange={e => {changeConfiguracaoPublico('superintendente',e.target.checked)}}
                                        />
                                    } label="Superintendente"  className={styles.radioOptions}/>
                                    <FormControlLabel value="Loja(CNPJ)" control={
                                        <Checkbox style={{color: '#5CCBE1' }}
                                            checked={configuracaoPublico.loja}
                                            onChange={e => {changeConfiguracaoPublico('loja',e.target.checked)}}
                                        />
                                    } label="Loja(CNPJ)"  className={styles.radioOptions}/>
                                    <FormControlLabel value="Vendedor" control={
                                        <Checkbox style={{color: '#5CCBE1' }}
                                            checked={configuracaoPublico.vendedor}
                                            onChange={e => {changeConfiguracaoPublico('vendedor',e.target.checked)}}
                                        />
                                    } label="Vendedor"  className={styles.radioOptions}/>
                                </FormControl>
                                </div>
                            <div>
                                <div className={styles.subtitleConfiguracao}>
                                    Lojas participantes
                                </div>
                                <FormControl className={styles.selects}>
                                    <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                    Regional
                                    </InputLabel>
                                    <Select
                                        labelId='select-status-label'
                                        label="Status"
                                        onChange={(e)=>{ setRegionalSelecionado( e.target.value ) }}
                                        value={regionalSelecionado}
                                        variant="filled"
                                        className="customFilledInput"
                                        >
                                        <MenuItem value="todos">Todos</MenuItem>
                                        {regional.map( (regiao) => {
                                            return(
                                                <MenuItem value={regiao} key={regiao}>{regiao}</MenuItem>
                                                )
                                            })}
                                    </Select>
                                </FormControl>
                                <FormControl className={styles.selects}>
                                    <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                    Filial
                                    </InputLabel>
                                    <Select
                                        labelId='select-status-label'
                                        label="Status"
                                        onChange={(e)=>{ setFilialSelecionado( e.target.value )}}
                                        value={filialSelecionado}
                                        variant="filled"
                                        className="customFilledInput"
                                        >
                                        <MenuItem value="todos">Todos</MenuItem>
                                        {filial.map( (info) => {
                                            return(
                                                <MenuItem value={info} key={info}>{info}</MenuItem>
                                                )
                                            })}
                                    </Select>
                                </FormControl>
                                <FormControl className={styles.selects}>
                                    <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                    Loja
                                    </InputLabel>
                                    <Select
                                        labelId='select-status-label'
                                        label="Status"
                                        onChange={(e)=>{ 
                                            if(e.target.value !== "todos"){
                                                setParceiroSelecionado( e.target.value )
                                                let parceiro = parceiros.find((p) => p.idParceiro === e.target.value)
                                                setNomeParceiroSelecionado(parceiro.nomeParceiro)
                                            } else{
                                                setParceiroSelecionado( e.target.value )
                                                setNomeParceiroSelecionado( e.target.value )
                                            }
                                        }}
                                        value={parceiroSelecionado}
                                        variant="filled"
                                        className="customFilledInput"
                                        >
                                        <MenuItem value="todos">Todos</MenuItem>
                                        {parceiros.map( (parceiro) => {
                                            return (
                                                <MenuItem value={parceiro.idParceiro} key={parceiro.nomeParceiro}>
                                                    {parceiro.nomeParceiro}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                <button className={styles.salvar} onClick={adicionarParceiro}>
                                    Adicionar
                                </button>
                                <div>
                                <br/>   
                                <div className={styles.subtitle}>
                                    Upload de arquivo
                                </div> 
                                <div>
                                    Para adicionar participantes em massa, baixe o arquivo modelo, adicione a planilha preenchida e em seguida clique em processar planilha
                                </div>
                                <FormControl>
                                    <Button href={modeloParticipanteCampanha} download className={'customButton bigButton bold'}>
                                        <FontAwesomeIcon icon={faDownload} className={styles.icon}/>
                                        Baixar modelo de planilha
                                    </Button>
                                </FormControl>
                                <FormControl>
                                    <input type='file' onChange={onFileChange} style={{display: 'none'}} ref={ref}/>
                                    <Button className={`customButton bigButton bold ${dados !== null ? styles.blue : null}`} onClick={callFileInput}>
                                        Adicionar planilha preenchida
                                    </Button>
                                </FormControl>
                                <FormControl>
                                    <Button className={`styles_processar__1ofBc bold`} onClick={parceiroImportacaoExcel}>
                                    {
                                        !loading ? 
                                        (
                                            <>
                                                <FontAwesomeIcon icon={faPlay} className={styles.icon}/>
                                                PROCESSAR PLANILHA
                                            </>
                                        ) :
                                        (
                                            <FontAwesomeIcon icon={faSpinner} className={styles.icon} spin={true}/>
                                        )
                                    }
                                    </Button>
                                </FormControl>
                                </div>
                                <div className={styles.subtitleConfiguracao}>
                                    Lojas participantes - adicionar
                                </div>
                                <div className={styles.addLojasWrapper}>
                                    {
                                        Boolean(data.parceiroAcaoAdicionar.length) ?
                                        data.parceiroAcaoAdicionar.map( (loja) => {
                                            return(
                                                <ParceiroCard parceiro={loja} key={loja.idLoja} remover={removerParceiro}/>
                                            )
                                        }) :
                                        (
                                            <div>
                                                Nenhum parceiro nesta lista
                                            </div>
                                        )
                                    }
                                </div>
                                {
                                    data.id && (
                                        <>
                                            <div className={styles.subtitleConfiguracao}>
                                                Lojas participantes - cadastradas
                                            </div>
                                            {
                                                Boolean(parceiroAcaoPresentes.length) ?
                                                    <div className={styles.searchWrapper}>
                                                        <TextField  
                                                            type="text"  
                                                            size="small"
                                                            onChange={(e) => {setBuscar(e.target.value)}}
                                                            label="Faça sua busca"
                                                            value={buscar}
                                                            variant="filled"
                                                            multiline
                                                            className="customFilledInput"
                                                            onKeyDown= {
                                                                (e) => {
                                                                    if (e.key === 'Enter') {
                                                                        findLojasParticipantesCadastradas();
                                                                        e.preventDefault();
                                                                    }
                                                                }
                                                            }
                                                            InputProps={{endAdornment: (
                                                                <button onClick={findLojasParticipantesCadastradas} className={styles.searchButton}>
                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                </button>
                                                            )}}
                                                        />
                                                    </div>
                                                :
                                                ""
                                            }
                                                
                                            <div className={styles.addLojasWrapper}>
                                                {
                                                    Boolean(parceiroAcaoPresentes.length) ?
                                                    parceiroAcaoPresentes.map((loja, i) => {
                                                        return(
                                                            <ParceiroCard parceiro={loja} key={loja.idLoja} remover={() => deletarParceiro(loja, i)}/>
                                                            )
                                                        }) :
                                                        (
                                                            <div>
                                                            Nenhum parceiro nesta lista
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            { maxPage > 1 && (
                                                <Paginacao maxPage={maxPage} page={page} setPage={setPage}/>
                                                )}
                                        </>
                                    )
                                }
                                <div className={styles.subtitleConfiguracao}>
                                    Lojas participantes - remover
                                </div>
                                <div className={styles.addLojasWrapper}>
                                    {
                                        Boolean(data.parceiroAcaoExcluidos.length) ?
                                        data?.parceiroAcaoExcluidos?.map( (loja) => {
                                            return(
                                                <ParceiroCard parceiro={loja} key={loja.idLoja}/>
                                                )
                                            }) :
                                            (
                                                <div>
                                                Nenhum parceiro nesta lista
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {/*<div className={styles.topSpacing}>
                                <div className={styles.subtitleConfiguracao}>
                                Premiação
                                </div>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">A campanha possui premiação?</FormLabel>
                                    <RadioGroup
                                    aria-label="possui-premiacao"
                                    defaultValue='sim'
                                    value={configuracaoPremiacao.existe}
                                    onChange={e => {setConfiguracaoPremiacao({ ...configuracaoPremiacao, existe: e.target.value })}}
                                    >
                                    <FormControlLabel value='sim' control={<Radio style={{color: '#5CCBE1' }}/>} label="Sim" className={styles.radioOptions}/>
                                    <FormControlLabel value='nao' control={<Radio style={{color: '#5CCBE1' }}/>} label="Não"  className={styles.radioOptions}/>
                                    </RadioGroup>
                                    </FormControl>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend">Tipo de benefício</FormLabel>
                                    <RadioGroup
                                    aria-label="tipo-premiacao"
                                    defaultValue="brindes e premios"
                                    value={configuracaoPremiacao.tipo}
                                    onChange={e => {  setConfiguracaoPremiacao({ ...configuracaoPremiacao, tipo: e.target.value })}}
                                    >
                                    <FormControlLabel value='0' control={<Radio style={{color: '#5CCBE1' }}/>} label="Informativo" className={styles.radioOptions}/>
                                    <FormControlLabel value='1' control={<Radio style={{color: '#5CCBE1' }}/>} label="Evento"  className={styles.radioOptions}/>
                                    <FormControlLabel value='2' control={<Radio style={{color: '#5CCBE1' }}/>} label="Brindes e prêmios"  className={styles.radioOptions}/>
                                    </RadioGroup>
                                    </FormControl>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend">Configuração do benefícios:</FormLabel>
                                    <TextField  type="text"  size="small"
                                    onChange={(e) => {setConfiguracaoPremiacao({ ...configuracaoPremiacao, link:e.target.value})}}
                                    label="Link"
                                    value={configuracaoPremiacao.link}
                                    variant="filled"
                                    multiline
                                    className="customFilledInput"
                                    />
                                    </FormControl>
                                <FormControl component="fieldset">
                                <FormLabel component="legend">Aceita acompanhantes?</FormLabel>
                                <RadioGroup
                                    aria-label="possui-premiacao"
                                    defaultValue="sim"
                                    value={configuracaoPremiacao.acompanhante}
                                    onChange={e => {setConfiguracaoPremiacao({ ...configuracaoPremiacao, acompanhante: e.target.value })}}
                                    >
                                    <FormControlLabel value="sim" control={<Radio style={{color: '#5CCBE1' }}/>} label="Sim" className={styles.radioOptions}/>
                                    <FormControlLabel value="nao" control={<Radio style={{color: '#5CCBE1' }}/>} label="Não"  className={styles.radioOptions}/>
                                    </RadioGroup>
                                    </FormControl>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend">Quantidade</FormLabel>
                                    <TextField  type="text"  size="small"
                                    type="number"
                                    onChange={(e) => {setConfiguracaoPremiacao({ ...configuracaoPremiacao, quantidade:e.target.value})}}
                                    value={configuracaoPremiacao.Quantidade}
                                    variant="filled"
                                    className="customFilledInput"
                                    />
                                    </FormControl>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend">Conteúdo:</FormLabel>
                                    <TextField  type="text"  size="small"
                                    onChange={(e) => {setConfiguracaoPremiacao({ ...configuracaoPremiacao, descricao:e.target.value})}}
                                    label="Descrição na página de detalhe"
                                    value={configuracaoPremiacao.descricao}
                                    variant="filled"
                                    multiline
                                    className="customFilledInput"
                                    />
                                    </FormControl>
                                </div>*/
                            }
                        </div>
                    </div>
                    {/*<div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card}>
                                <div className={styles.subtitle}>
                                Imagens para a Vitrine BV
                                </div>
                                <div className={styles.divImageList}>
                                <ButtonsImagesCampain
                                versao = 'Versão Desktop'
                                texto = 'Destaque de conteúdo para a vitrine do portal.'
                                width = '1200'
                                height = '300'
                                widthMM = '317.5'
                                        heightMM = '79.375'
                                        image={data.destaqueDesktop}
                                        changeImage={(file)=>{setData({...data, 'destaqueDesktop':file})}}
                                    />
                                    <ButtonsImagesCampain
                                        versao = 'Versão Mobile'
                                        texto = 'Destaque de conteúdo para a vitrine do portal.'
                                        width = '400'
                                        height = '400'
                                        widthMM = '132.29'
                                        heightMM = '132.29'
                                        image={data.destaqueMobile}
                                        changeImage={(file)=>{setData({...data, 'destaqueMobile':file})}}
                                    />
                                    <ButtonsImagesCampain
                                        versao = 'Versão Desktop'
                                        texto = 'Conteúdo no detalhe do benefício.'
                                        width = '1200'
                                        height = '300'
                                        widthMM = '317.5'
                                        heightMM = '79.375'
                                        image={data.conteudoDesktop}
                                        changeImage={(file)=>{setData({...data, 'conteudoDesktop':file})}}
                                    />
                                    <ButtonsImagesCampain
                                        versao = 'Versão Mobile'
                                        texto = 'Conteúdo no detalhe do benefício.'
                                        width = '400'
                                        height = '400'
                                        widthMM = '132.29'
                                        heightMM = '132.29'
                                        image={data.conteudoMobile}
                                        changeImage={(file)=>{setData({...data, 'conteudoMobile':file})}}
                                    />
                                </div>
                                
                            </div>
                        </div>
                        </div>*/}
                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card}>
                                <div className={styles.subtitle}>
                                    Ações
                                </div>
                                { (data.id && data.status === 1 ) && (<button className={styles.encerrar} onClick={encerrar}>
                                    Encerrar ação
                                </button>)}
                                { (data.id && (data.status === 2 || data.status === 0) ) && (<button className={styles.ativar} onClick={encerrar}>
                                    Ativar ação
                                </button>)}
                                <button className={styles.salvar} onClick={enviar}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalLoading
                    open={modalLoading} 
                    size="lg"
                />
                <Modal open={openModalComplete} close={closeModalComplete} size={'sm'}>
                    <div className="pad20"> 
                        <div className="row">
                    
                            <div className="col-sm-12">
                                <Paticipantes 
                                    participantes={participantes}
                                />
                            </div>

                            <div className="col-sm-12 text-center">
                                <button onClick={closeModalComplete}
                                    className="btn btn-outline-info btn-lg mt20 padL40 padR40 mr10"
                                >
                                    Voltar
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )}
        </>

    );
}

export default AdicionarCampanha;